import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const settings = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getSettings () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/configs`)
  },
  getSiteSettings (siteId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${siteId}/configs`)
  },
  saveSettings (settings) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/configs`, settings)
  },
  saveSiteSettings(settings){
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${settings.siteId}/configs`, settings)
  }
}
export default settings
